import { styled } from '@mui/material';
import { Form } from 'formik';

import TextField from '@common/components/Form/TextField';

export const StyledGoalsTextField = styled(TextField)({
	padding: '0px',
	borderRadius: '8px',

	'& .MuiInputBase-root': {
		padding: '8px',

		'& textarea': {
			padding: 0,
		},
	},
});

export const StyledGoalsForm = styled(Form)(() => ({
	display: 'flex',
	alignItems: 'center',
	flexDirection: 'column',
	gap: '8px',
}));

export const StyledGoalsItemsWrap = styled('div')({
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
});
